export default __webpack_public_path__ + "static/media/technology.7468607b.PNG";